import { ACTIVE_SESSIONS } from '../constant/actionTypes';

const getActiveSessionData = (state, action) => {
  switch (action.type) {
    case ACTIVE_SESSIONS.GET.INITIATE:
      return { isFetching: true };
    case ACTIVE_SESSIONS.GET.SUCCESS:
      return {
        isFetching: false,
        data: action.payload,
      };
    case ACTIVE_SESSIONS.GET.ERROR:
      return {
        isFetching: false,
        data: action.payload,
      };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getActiveSessionData;
